import { memo, ReactNode, useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate, useRouterState } from '@tanstack/react-router'

import { TabContext } from './TabContext'

interface IProps {
  children: ReactNode
  defaultTab: IdType
  onSetCurrent?: (tabId: IdType) => void
}

export const TabProvider = memo(function TabProvider({ defaultTab, onSetCurrent, children }: IProps) {
  const {
    location: { hash }
  } = useRouterState()
  const lastSelectedTab = useRef<IdType>(defaultTab)
  const navigate = useNavigate()
  const initial = hash || defaultTab
  const [currentTab, setCurrentTab] = useState<IdType>(initial)

  const handleSetCurrentTab = useCallback((tabId: IdType) => {
    setCurrentTab(tabId)
    navigate({ hash: String(tabId) })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (currentTab !== lastSelectedTab.current) {
      onSetCurrent?.(currentTab)
      lastSelectedTab.current = currentTab
    }
  }, [currentTab, onSetCurrent])

  useEffect(
    () => () => {
      navigate({ hash: undefined })
    },
    []
  )

  return (
    <TabContext.Provider value={{ currentTab, setCurrentTab: handleSetCurrentTab }}>{children}</TabContext.Provider>
  )
})
